var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { INPUT_LABEL, INPUT, INPUT_GROUP, IS_INVALID, INPUT_GROUP_POST_FIX, TEXT_INPUT } from "../../../classConstants";
import { Flex } from '../../Flex';
import styled from 'styled-components';
import useFieldApi from '@data-driven-forms/react-form-renderer/dist/cjs/use-field-api';
import { getClassName } from '../../../helpers';
import { usePresentationComponent } from '../../../AppContext';
import { SvgIcon } from '../../../icons';
import useFormApi from '@data-driven-forms/react-form-renderer/dist/cjs/use-form-api';
var TextAreaNoStyle = function (props) {
    var _a;
    var TextAreaComponent = usePresentationComponent("textarea");
    var className = props.className, name = props.name, label = props.label, required = props.required, _b = props.isInline, isInline = _b === void 0 ? false : _b, _c = props.input, input = _c === void 0 ? { name: '' } : _c, _d = props.children, children = _d === void 0 ? null : _d, _e = props.meta, _f = _e === void 0 ? {} : _e, _g = _f.touched, touched = _g === void 0 ? false : _g, _h = _f.invalid, invalid = _h === void 0 ? false : _h, _j = _f.error, error = _j === void 0 ? '' : _j, textareaAttributes = __rest(props, ["className", "name", "label", "required", "isInline", "input", "children", "meta"]);
    var isInvalid = !!props.errorMessage || (touched && error);
    var renderDisplayText = function () {
        if (!label)
            return null;
        return React.createElement("span", { className: INPUT_LABEL }, label);
    };
    var renderTextArea = function () {
        var textareaProps = __assign(__assign(__assign({}, input), textareaAttributes), { 
            // defaultValue: (children?.toString() || props.value) ? undefined : props.defaultValue,
            onKeyDown: onKeyDown, onFocus: null, onBlur: null });
        return TextAreaComponent
            ? React.createElement(TextAreaComponent, __assign({}, textareaProps))
            : React.createElement(FieldWrap, null,
                React.createElement("textarea", __assign({ className: INPUT + " " + TEXT_INPUT + " ws-textarea" }, textareaProps)),
                isInvalid && React.createElement(ErrorIcon, { type: "error" }));
    };
    var originalOnKeyDown = input.onKeyDown || (function () { });
    var onKeyDown = React.useCallback(function (e) {
        var _a;
        if (e.keyCode === 13) {
            e.preventDefault();
            var target = e.target;
            var position = target.selectionStart;
            var value = target.value;
            target.value = value.substr(0, position) + "\n" + value.substr(position);
            target.selectionStart = position + 1;
            target.selectionEnd = position + 1;
            (_a = input.onChange) === null || _a === void 0 ? void 0 : _a.call(input, e);
        }
        originalOnKeyDown(e);
    }, []);
    return (React.createElement("div", { className: getClassName(className, INPUT_GROUP, name + INPUT_GROUP_POST_FIX, "textarea" + INPUT_GROUP_POST_FIX) },
        React.createElement(Flex, { isInline: isInline, forwardedAs: 'label', className: getClassName(name + "-input", (_a = {}, _a[IS_INVALID] = isInvalid, _a)) },
            renderDisplayText(),
            renderTextArea())));
};
var FieldWrap = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: relative;\n    .", " { width: 100%; }\n"], ["\n    position: relative;\n    .", " { width: 100%; }\n"])), INPUT);
var ErrorIcon = styled(SvgIcon)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    position: absolute;\n    right: .6em;\n    top: .6em;\n    height: calc(100% - .6em);\n    ", "\n"], ["\n    position: absolute;\n    right: .6em;\n    top: .6em;\n    height: calc(100% - .6em);\n    ", "\n"])), function (_a) {
    var width = _a.width;
    return "width : " + (width || "1em") + ";";
});
export var TextArea = styled(TextAreaNoStyle)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    &.", " textarea {\n        appearance: none;\n        padding-right: 2.7em !important;\n    }\n"], ["\n    &.", " textarea {\n        appearance: none;\n        padding-right: 2.7em !important;\n    }\n"])), IS_INVALID);
export var ReactiveTextArea = React.memo(function (props) {
    var className = props.className, name = props.name;
    var _a = useFieldApi(props), input = _a.input, reactiveProps = __rest(_a, ["input"]);
    var formOptions = useFormApi();
    input.onChange = React.useCallback(function (e) {
        formOptions.change(name, e.target.value);
    }, [name]);
    return React.createElement(TextArea, __assign({ className: className, name: name }, reactiveProps, { input: input }));
});
var templateObject_1, templateObject_2, templateObject_3;
